import { validateFormatCanadianPostal } from '../validation/validate-format-canadian-postal';

export function normalizePostalCode(zip, countryAlpha3) {
  function normalizeZipCode(zipCode) {
    zipCode = zipCode || '';
    // Remove any non-digit characters (for US zip codes)
    return zipCode.replace(/\D/g, '').trim();
  }
  if (countryAlpha3 === 'USA') {
    return normalizeZipCode(zip);
  } else if (countryAlpha3 === 'CAN') {
    return validateFormatCanadianPostal(zip).formattedPostalCode || '';
  } else {
    return (zip || '').trim();
  }
}
